import api from '@/services/Api';
import Titel from '@/types/Titel';
import { successSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import { RootState, TitelState } from '@/store/types';

type Context = ActionContext<TitelState, RootState>;

export const titel: Module<TitelState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            titel: false,
        },
        titel: [],
    },
    actions: {
        loadTitel({ commit }: Context): void {
            commit('setLoadersTitel', true);
            commit('setTitel', []);

            api.post('verwaltung/titel/load')
                .then((response: AxiosResponse) => commit('setTitel', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersTitel', false));
        },
        updateTitel({ commit, dispatch }: Context, payload: Titel): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/titel/speichern', payload)
                .then(() => {
                    successSwal('Titel', 'gespeichert');
                    dispatch('loadTitel');
                    dispatch('terminkalender/exportSync', { source: 'titel' }, { root: true });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteTitel({ commit, dispatch }: Context, payload: Titel): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/titel/loeschen', payload)
                .then(() => {
                    successSwal('Titel', 'gelöscht');
                    dispatch('loadTitel');
                    dispatch('terminkalender/exportSync', { source: 'titel' }, { root: true });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
    },
    mutations: {
        setTitel(state: TitelState, payload: Partial<Titel>[]): void {
            state.titel = payload.map((data) => new Titel(data));
        },
        setDialogsDetail(state: TitelState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: TitelState, visible: boolean): void {
            state.loaders.save = visible;
        },
        setLoadersDelete(state: TitelState, visible: boolean): void {
            state.loaders.delete = visible;
        },
        setLoadersTitel(state: TitelState, visible: boolean): void {
            state.loaders.titel = visible;
        },
    },
};
